import React, { useEffect } from 'react';
import QuizTimer from "./QuizTimer";
import QuizHeaderLoader from "./../Loader/QuizHeaderLoader";
import LanguageSwitcher from "../../common/Header/LanguageSwitcher";
import { useStyles } from "examsbook-react-sdk/custom-hooks";
import { useSelector } from "react-redux";
import SubmitButton from "./SubmitButton";
import { fullScreenMode } from "examsbook-react-sdk/common";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

/**
 * Quiz header
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizHeader(props) {
    const {
        quizPage, name, viewMode, mode, submitQuiz, drawerToggle, duration, usedTime,
        setTimeTaken, isLoading, toggleDrawerHandler, pauseQuiz, handleQuizPauseChange
    } = props;
    const navigate = useNavigate();
    const quiz = useSelector((state) => state.quiz);
    const classes = useStyles(styles)();
    const headerClass = quizPage ? classes.quizHeader : '';
    //change document name as per quiz name.
    useEffect(() => {
        fullScreenMode();
        if (name) {
            document.title = name;
        }
    }, [ name ]);

    function goToAllTest() {
        navigate('/my-app/tests/result/' + quiz.id);
    }

    return (
        !isLoading ?
            <div className={headerClass}>
                {!viewMode ? <QuizTimer viewMode={viewMode}
                                        mode={mode}
                                        setTimeTaken={setTimeTaken}
                                        submitQuiz={submitQuiz}
                                        duration={duration}
                                        usedTime={usedTime}
                                        pauseQuiz={pauseQuiz}/>
                    : null
                }

                {viewMode ?
                    <div className={classes.solutionMode} onClick={goToAllTest}>
                        <ArrowBackIcon/>
                        <span>Report Card</span>
                    </div> : null}
                <div onClick={toggleDrawerHandler}
                     className={classes.menuIcon + ' ' + (!drawerToggle ? classes.changeColor : null)}>
                    <i className="fa fa-th" aria-hidden="true"/>
                </div>
                <div className={classes.title}>{name}</div>
                {/* <div className={classes.questionNumber}>{number + ' / ' + total}</div> */}
                {quizPage ?
                    <div>

                        <div className="notification-bar quiz-notification-bar">
                            <ul className="right-menus">
                                <li className={classes.hideElementForMobile}>
                                    <LanguageSwitcher/>
                                </li>
                                {/* <li id="fullscreenMode"
                                  className ={'fa '+ (isFullscreen ? 'fa-compress': 'fa-expand') + ' ' + classes.overrideHoverEffect + ' ' + classes.hideElementForMobile }
                                  style={{fontSize: 20}}
                                  onClick={() => handleFullScreen()}
                                  title="Fullscreen Mode">
                               </li> */}
                                {mode !== 'live-test' && !viewMode ?
                                    <li onClick={() => handleQuizPauseChange(!pauseQuiz)}
                                        className={classes.overrideHoverEffect + ' ' + classes.hideElementForMobile}
                                        id="playPauseIcon">

                                        {pauseQuiz ?
                                            <i className="fa fa-play-circle-o" title="Play Quiz"
                                               style={{ fontSize: 30 }}></i>
                                            :
                                            <i className="fa fa-pause-circle-o" title="Pause Quiz"
                                               style={{ fontSize: 30 }}></i>
                                        }
                                    </li>
                                    : ''}
                                <li className={classes.overrideHoverEffect}>
                                    <SubmitButton mode={mode} hideSubmitButton={true} viewMode={viewMode}
                                                  submitQuiz={submitQuiz} quizId={quiz.id}/>
                                </li>
                            </ul>
                        </div>
                    </div> : ''}
            </div> : <div className={classes.quizHeader + ' ' + classes.quizLoader}>
                <QuizHeaderLoader/>
            </div>
    );
}

const styles = theme => ({
    quizHeader: {
        backgroundColor: '#008E76',
        height: 66,
        marginBottom: 0,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        justifyContent: 'space-between',
        '@media (max-width: 767px)': {
            height: 55,
            alignItems: 'center',
            justifyContent: 'flex-end',
            zIndex: 9999,
        }
    },
    overrideHoverEffect: {
        '&:hover': {
            background: 'none !important'
        }
    },
    logo: {
        float: 'left',
        '& img': {
            width: '100%',
            maxWidth: 150,
            padding: '10px'
        },
        '@media (max-width:767px)': {
            display: 'none',
        }
    },
    title: {
        float: 'left',
        lineHeight: '66px',
        margin: '0 15px',
        color: '#fff9f9',
        fontSize: 18,
        fontWeight: 500,
        maxWidth: '60%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        '@media (max-width:767px)': {
            display: 'none',
        }
    },

    menuIcon: {
        display: 'none',
        float: 'left',
        '& i': {
            color: '#fff',
            cursor: 'pointer',
            fontSize: 24
        },
        '@media (max-width:767px)': {
            display: 'flex',
            background: '#12a188',
            padding: '6px 8px',
            '& i': {
                fontSize: 18,
                position: 'relative',
                top: 1
            }
        }
    },
    changeColor: {
        background: '#5DF2D6',
    },
    questionNumber: {
        display: 'none',
        '@media (max-width:767px)': {
            display: 'block',
            color: '#fff',
            lineHeight: '55px',
            fontSize: 16,
            fontWeight: 'bold',
            left: 55,
            position: 'absolute',
        }
    },
    quizLoader: {
        height: '66px'
    },
    hideElementForMobile: {
        display: 'inline-block',
        '&#fullscreenMode': {
            background: '#12a188',
            lineHeight: '8px !important',
            '&:hover': {
                background: '#12a188 !important',
            }
        },
        '&#playPauseIcon': {
            background: '#12a188',
            lineHeight: '8px !important',
            padding: '4px 6px!important',
            marginRight: 0,
            '& i': {
                marginLeft: 0
            },
            '&:hover': {
                background: '#12a188 !important',
            }
        },
        '@media (max-width: 767px)': {
            display: 'none !important'
        }
    },
    solutionMode: {
        display: 'none',
        '@media (max-width: 767px)': {
            display: 'flex',
            alignItems: 'center',
            left: 10,
            position: 'absolute',
            color: '#fff',
            fontSize: 16,
            zIndex: 1,
            '& i': {
                color: '#fff',
                marginRight: 10,
                fontSize: 16
            }
        }
    }
});
export default QuizHeader;
